import React from 'react';
import styled from 'styled-components';
import { MdDashboard, MdAssignment, MdEventAvailable, MdSchedule, MdMenu } from 'react-icons/md';
import theme from '../styles/theme';

const Bar = styled.nav`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: stretch;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    background: #ffffff;
    border-top: 1px solid #e5e7eb;
    padding: 6px 4px calc(6px + env(safe-area-inset-bottom));
    box-shadow: 0 -2px 12px rgba(15, 23, 42, 0.06);
  }
`;

const itemStyles = `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 6px 2px;
  border: none;
  background: transparent;
  border-radius: 12px;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s ease;

  svg {
    font-size: 22px;
  }
`;

const Tab = styled.a`
  ${itemStyles}
  color: ${(p) => (p.$active ? theme.primaryDark : '#6b7280')};
`;

const MoreButton = styled.button`
  ${itemStyles}
  color: #6b7280;
`;

const TabLabel = styled.span`
  font-size: 10.5px;
  font-weight: 600;
`;

const tabs = [
  { name: 'Home', href: '/app/dashboard', icon: <MdDashboard /> },
  { name: 'Submissions', href: '/app/submissions', icon: <MdAssignment /> },
  { name: 'Attendance', href: '/app/attendance', icon: <MdEventAvailable /> },
  { name: 'Timetable', href: '/app/timetable', icon: <MdSchedule /> },
];

// Quick-access bottom tab bar for mobile, mirroring the most-used items from
// StudentSidebar's full navigation list. "More" opens that same drawer for
// the remaining items (Event Attendance, My Exam, Ticket, Profile) instead
// of duplicating them here -- five-plus icons stop being scannable at a
// glance on a phone-width tab bar.
export default function MobileTabBar({ onMore }) {
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
  const isActive = (href) =>
    href === '/app/dashboard' ? currentPath === href : currentPath.startsWith(href);

  return (
    <Bar>
      {tabs.map((tab) => {
        const active = isActive(tab.href);
        return (
          <Tab key={tab.name} href={tab.href} $active={active}>
            {tab.icon}
            <TabLabel>{tab.name}</TabLabel>
          </Tab>
        );
      })}
      <MoreButton type="button" onClick={onMore} aria-label="More navigation options">
        <MdMenu />
        <TabLabel>More</TabLabel>
      </MoreButton>
    </Bar>
  );
}
